export default {"src":"/_next/static/media/miare.ff8e5953.svg","height":36,"width":105,"blurWidth":0,"blurHeight":0};